import React, {Component} from 'react';
import {FadeIn, FadeInDown} from 'animate-components';
let avatar = require('../images/niti.jpg');

let shortBio = "A passionate software developer. Open-minded and computer geek. An open source e" +
      "nthusiast and open data analyst. A dedicated developer and a trainer by sharing " +
      "its knowledge to community.";

const TopBar = () => {
   return <h2 className="topbar">
      <a href="https://arianithetemi.github.io/">Arianit Hetemi</a>
   </h2>
};

const Jumbotron = () => {
   return (
      <div className="jumbotron">
         <div className="row jumbotron-content">
            <div className="col-md-2 offset-md-2 avatar-container">
               <img src={avatar} className="img-fluid avatar rounded-circle" alt="A.H Avatar"/>
            </div>
            <div className="col-md-6">
               <p className="short-bio">{shortBio}</p>
            </div>
         </div>
      </div>
   );
}

class Header extends Component {
   render() {
      return (
         <div>
            <FadeIn duration="1.2s" timingFunction="ease-out">
               <FadeInDown>
                  <TopBar/>
               </FadeInDown>
               <Jumbotron/>
            </FadeIn>
         </div>
      );
   }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js